export default __webpack_public_path__ + "static/media/150.44b91a66.png";